import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "113",
  height: "112",
  viewBox: "0 0 113 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_2385_938)\"><path d=\"M112.667 0H0.666504V112H112.667V0Z\" fill=\"#DAF6FF\"></path><path d=\"M79.9997 18.6667H33.333C25.601 18.6667 19.333 24.9347 19.333 32.6667V79.3334C19.333 87.0653 25.601 93.3334 33.333 93.3334H79.9997C87.7317 93.3334 93.9997 87.0653 93.9997 79.3334V32.6667C93.9997 24.9347 87.7317 18.6667 79.9997 18.6667Z\" fill=\"#00BBF9\"></path><path d=\"M56.6665 18.6667H79.9998C83.7129 18.6667 87.2738 20.1417 89.8993 22.7672C92.5248 25.3927 93.9998 28.9537 93.9998 32.6667V37.3334H56.6665V18.6667Z\" fill=\"#80DDFC\"></path></g><defs><clipPath id=\"clip0_2385_938\"><rect width=\"112\" height=\"112\" fill=\"white\" transform=\"translate(0.666504)\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }